import * as React from 'react';
import axios from 'axios';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import { TextField, DefaultButton } from '@fluentui/react';


export class FeatureRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            message: '',
            errorMessage: '',
            showSuccess: false,
            showError:false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMessageChange = this.handleMessageChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        var model = {
            Value: this.state.message
        }

        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/FeatureRequest", model)
            .then((response) => {
                this.setState({
                    showSuccess: true,
                    message: '',
                    showSuccess:true
                });
            });
    }

    handleMessageChange(event) {
        this.setState({
            message: event.target.value
        });
    }

render() {
    return (
        <form id="ContactForm" name="ContactForm" className="default-form" style={{ maxWidth: 400 }} noValidate="noValidate" autoComplete="off" onSubmit={this.handleSubmit}>
            {this.state.showError &&
                <div className="alert alert-danger" style={{ 'margin': "5px 0px 0px"}}>
                    <strong>Error:</strong> {this.state.errorMessage}
                </div>
            }
 
            {this.state.showSuccess  &&
                <div className="alert alert-info" style={{ 'margin': "5px 0px 0px" }}>
                    <strong>Awesome!</strong> Thanks for your request.
                </div>
            }
           
              
            <div className="form-group  ">
                <TextField className="form-control" id="Message" name="Message" multiline rows={3} 
                        value={this.state.message}
                        onChange={this.handleMessageChange}/>
                </div>

            <div className="m-t-30">
                <DefaultButton
                    text="Submit"
                    primary
                    onClick={this.handleSubmit}
                />
                </div>
            </form>
    );
}
}
